import { get } from "lodash-es";
import React, { FC, PropsWithChildren } from "react";

import {
  Alert,
  AlertTitle,
  Divider,
  Link,
  List,
  ListItem,
} from "@mui/material";

import { setClusterAndOrg } from "../slices/current";
import { useDispatch, useSelector } from "../store";
import { hasPermission } from "../utils/permissions";
import Page from "./Page";

interface RoleGuardProps {
  warn: boolean;
  namespaceId: string;
  role: string;
}

const NamespaceRoleGuard: FC<PropsWithChildren<RoleGuardProps>> = ({
  children,
  warn = true,
  namespaceId,
  role,
}) => {
  const dispatch = useDispatch();
  const { organizationId } = useSelector((state) => state.current);
  const { byId } = useSelector((state) => state.namespaces);
  const accessibleNamespaces = Object.values(byId).filter((tn) => {
    return hasPermission(tn.namespace.role, "viewer");
  });

  const effectiveNamespace = get(byId, namespaceId);

  if (!namespaceId) {
    return <></>;
  }

  if (
    hasPermission(
      get(byId, namespaceId + ".namespace.role", "") as string,
      role,
    )
  ) {
    return <>{children}</>;
  }

  if (!warn) return <></>;

  return (
    <Page>
      <Alert
        severity="info"
        sx={{
          "& .MuiAlert-message": {
            width: "95%",
          },
        }}
      >
        <AlertTitle>Insufficient Permissions</AlertTitle>A minimum {role} access
        role in {effectiveNamespace?.namespace.name} namespace is required.
        Currently {effectiveNamespace?.namespace?.role || "no access"}.
        {!!accessibleNamespaces.length && (
          <>
            <Divider
              sx={{
                marginTop: 3,
                marginBottom: 3,
              }}
              variant={"fullWidth"}
            />
            <AlertTitle>Accessible Namespaces</AlertTitle>
            <List dense disablePadding>
              {accessibleNamespaces.map((node) => (
                <ListItem key={"namespace" + node.namespace.id}>
                  <Link
                    href="#"
                    onClick={() =>
                      dispatch(
                        setClusterAndOrg({
                          clusterId: node.namespace.id,
                          organizationId,
                        }),
                      )
                    }
                  >
                    {node.namespace.name}
                  </Link>
                </ListItem>
              ))}
            </List>
          </>
        )}
      </Alert>
    </Page>
  );
};

export default NamespaceRoleGuard;
